import styled from 'styled-components';

interface DetailsCollapsibleSectionProps {
  isCollapsed?: boolean;
}

export const CollapsibleSectionContainer = styled.div<DetailsCollapsibleSectionProps>`
  height: ${props => (props.isCollapsed ? '0' : 'calc(100% - 156px)')};
  width: 320px;

  max-height: -webkit-fill-available;
  max-height: -moz-available;
  max-height: fill-available;
  display: flex;
  flex-direction: column;
  border-radius: 0 0 8px 8px;
  margin-left: 12px;
  position: absolute;
  background: #ffffff;
  box-shadow: 0px 2px 4px rgba(92, 101, 117, 0.3), 0px 0px 1px rgba(92, 101, 117, 0.47);
  top: 19px;
  margin-top: 131px;

  @media (max-width: 768px) {
    position: static;
    width: 100%;
    height: auto;
    max-height: none;
    margin-left: 0;
    margin-top: 0;
    border-radius: 0;
    box-shadow: none;
    flex: 1;
    min-height: 0;
  }
`;

export const Collapsable = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: #fff;
  border-radius: 0px 0px 6px 6px;
  box-shadow: 0px 0px 40px -6px rgba(0, 0, 0, 0.4);
  padding: 5px;
  cursor: pointer;

  @media (max-width: 768px) {
    display: none;
  }
`;
